import fetcher from '@/services/fetcher'
import type { FeaturedWinner } from '@/types'
import { defineStore } from 'pinia'

type FeaturedWinnersStoreState = {
  winners: Map<string, FeaturedWinner>
  fetchPromise: Promise<Array<FeaturedWinner>> | null
}

export const useFeaturedWinnersStore = defineStore('featured-winners', {
  state: (): FeaturedWinnersStoreState => ({
    winners: new Map<string, FeaturedWinner>(),
    fetchPromise: null,
  }),

  getters: {
    winnersArray(): Array<FeaturedWinner> {
      return Array.from(this.winners.values())
    },
  },

  actions: {
    async fetchFeaturedWinners(): Promise<void | Array<FeaturedWinner>> {
      // return the fetch winners promise to prevent multiple calls
      if (this.fetchPromise) {
        return this.fetchPromise
      }

      if (this.winners.size) {
        return this.winnersArray
      }

      this.fetchPromise = fetcher
        .get<FeaturedWinner>('/data/featured-winners.json', false, {
          key: 'ticket',
          map: this.winners,
        })
        .then(() => this.winnersArray)

      return this.fetchPromise ?? this.winnersArray
    },
  },
})
